// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-item{
    display: flex;
    gap: 20px;
    align-items: start;
    text-decoration: none;
}

.menu-item__logo{
    height: fit-content;
    line-height: 1;
}

.menu-item__text{
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.menu-item__text_title{
    font-size: 20px;
    color: #4B2D10;
}

.menu-item__text_condition{
    color: #BB8D6C;
    font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/MenuProfile/MenuProfileItem/MenuProfileItem.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB","sourcesContent":[".menu-item{\n    display: flex;\n    gap: 20px;\n    align-items: start;\n    text-decoration: none;\n}\n\n.menu-item__logo{\n    height: fit-content;\n    line-height: 1;\n}\n\n.menu-item__text{\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.menu-item__text_title{\n    font-size: 20px;\n    color: #4B2D10;\n}\n\n.menu-item__text_condition{\n    color: #BB8D6C;\n    font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
